import { getLocation } from 'core/util/default'
import React, { useEffect, useRef } from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import SectionModal from './Section/SectionModal'
import SectionSnackbar from './Section/SectionSnackbar'
import { useLocation } from 'react-router-dom'
import { GAHelper } from 'core/ga'
import { GA_EVENT } from 'core/ga/enums'

import { STORE_ROOT_PROPS } from 'core/store/global'
import { useRecoilValue } from 'recoil'

interface PageLayoutProps {}

const PageLayout: React.FC<PageLayoutProps> = (props) => {
  const pageRef = useRef<HTMLDivElement>(null)
  const param = useParams()

  const root = useRecoilValue(STORE_ROOT_PROPS)
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [param])

  useEffect(() => {
    new GAHelper().sendEvent(GA_EVENT.VIEW, {
      partnersId: root?.partnerId,
      location: getLocation(location),
    })
  }, [location, root?.partnerId])

  return (
    <StyledPageLayout className="sauceflex_page_layout" ref={pageRef}>
      {props.children}
      <SectionSnackbar />
      <SectionModal />
    </StyledPageLayout>
  )
}

const StyledPageLayout = styled.div`
  min-width: 320px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  background-color: ${(props) => props.theme.color.primary};
  position: relative;
`
export default PageLayout
